<template>
  <div class="login">
    <div class="divider mobile-small-hide"></div>
    <div class="divider mobile-small-hide"></div>
    <b-container>
      `<b-row align-h="center">
        <b-col md="11" lg="9" xl="6">
          <h2>
            Mohon maaf, pengisian BNI Service Rating hanya bisa dilakukan saat Outlet
            Buka. Terima kasih.
          </h2>
        </b-col> </b-row
      >`
    </b-container>
    <vue-touch-keyboard
      id="keyboard"
      :options="options"
      v-if="visible"
      :layout="layout"
      :cancel="hide"
      :accept="accept"
      :input="input"
      :change="getOutlet()"
    />
  </div>
</template>

<script>
import storage from "@/storage";
import api from "@/api/outlets";
export default {
  name: "landing",
  data() {
    return {
      visible: false,
      layout: "normal",
      input: null,
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      outlets: null,
      hasResult: false,
      loadingText: "",
      params: {
        q: "",
        page: 1,
      },
    };
  },
  mounted() {
    storage.clearData();
    this.getOutlet();
  },
  methods: {
    getOutlet() {
      var self = this;
      this.loadingText = "Loading...";
      api
        .get(this.params.page, this.params.q)
        .then(function (response) {
          // handle success
          if (response.data.data.length > 0) {
            self.hasResult = true;
            self.outlets = response.data.data;
          } else {
            self.hasResult = false;
            self.outlets = null;
            self.loadingText = "Outlet tidak ditemukan";
          }
          // console.log(self.outlets);
        })
        .catch(function (error) {
          console.log(error);
          self.loadingText = "Outlet tidak ditemukan";
          self.hasResult = false;
        });
    },
    setLocation(outlet_code) {
      this.$router.push(`/home/${outlet_code}`);
    },
    accept() {
      this.hide();
    },
    show(e) {
      this.input = e.target;
      this.layout = e.target.dataset.layout;

      if (!this.visible)
        if (
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.visible = true;
        }
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-block {
  display: none;
}
</style>
